import * as styles from "./UrlList.css";
import { listCard } from "./fields.css";

import { useAtomValue } from "jotai";

import { Fieldset, FieldsetLegend } from "@frontend/components/atoms/Fieldset";
import { Input } from "@frontend/components/atoms/Input";
import { useArrayField, useField } from "@frontend/hooks/form";
import { getUrlMask } from "@frontend/utils/masks";
import { Trans } from "@lingui/react/macro";

import { useContactForm } from "../../hooks/useContactForm";
import { ContactUrlPlaceLabels } from "../../i18n";
import { isEditModeAtom } from "../../stores";
import type { ContactUrl, UrlListItemUrlField } from "../../types";
import { AddButton } from "./AddButton";
import { ClipboardButton } from "./ClipboardButton";
import { FieldList } from "./FieldList";
import { Place } from "./Place";

export function UrlList() {
  const { contactForm } = useContactForm();

  const field = contactForm.fields.urls;

  const rows = useArrayField(field);

  const editMode = useAtomValue(isEditModeAtom);

  const removeHandler = (index: number) => {
    rows.remove(rows.itemAtoms[index]!);
  };

  const insertHandler = () => {
    rows.append({ place: "", url: "" } as ContactUrl);
  };

  return (
    <Fieldset variant="list" orientation="horizontal" className={listCard}>
      <FieldsetLegend
        count={rows.items.length}
        action={editMode && <AddButton onClick={insertHandler} />}
      >
        <Trans>URLs</Trans>
      </FieldsetLegend>
      <FieldList
        field={field}
        onRemove={removeHandler}
        renderLeft={(item) => (
          <Place field={item.fields.place} labels={ContactUrlPlaceLabels} />
        )}
        renderRight={(item) => <UrlListItemUrl field={item.fields.url} />}
      />
    </Fieldset>
  );
}

function UrlListItemUrl({ field }: { field: UrlListItemUrlField }) {
  const editMode = useAtomValue(isEditModeAtom);

  const { value, setValue, error } = useField(field);

  const handleOpenUrl = () => {
    if (value) {
      window.open(value, "_blank");
    }
  };

  return editMode ? (
    <Input
      value={value}
      onValueChange={setValue}
      invalid={null !== error}
      mask={getUrlMask()}
      size="sm"
    />
  ) : (
    <>
      <span className={styles.url} onClick={handleOpenUrl}>
        {value}
      </span>
      <ClipboardButton value={value ?? ""} />
    </>
  );
}
